<style scoped>
    @import url("../../../styles/smartControl/formExibHist.scss");
</style>

<template>
    <div class="box_formExibHist">

        <!-- LOADING -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <!-- DIALOG -->
        <v-dialog v-model="flagDialog" width="auto" max-width="95vw">
            <div class="" v-if="flagDialog">
                <!-- O componente form -->
                <DialogCalendar v-if="flagDialog" 
                @fromDialog="desableDialogDT($event)" 
                />
            </div>
        </v-dialog>

        <!-- DIALOG -->
        <v-dialog v-model="flagDialogHR" width="auto" max-width="95vw">
            <div class="" v-if="flagDialogHR">
                <!-- O componente form -->
                <DialogHR v-if="flagDialogHR" 
                @fromDialog="desableDialogHR($event)" 
                />
            </div>
        </v-dialog>

        <!--<div class="mainTit mb-2">
            <span>IRRIGAÇÃO EXTERNA</span>
        </div>-->

        <!-- USE CASE -->
        <div class="menuForm" v-if="!flagLoading">

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Dispositivo:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="deviceSelected"
                    :items="liExibSelect"
                    item-title="titulo"
                    item-value="idLocal"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="tmpSaveIndex()"
                    ></v-autocomplete>
                    <!-- :menu-props="{ locationStrategy: 'static' }" -->
                    <!-- este acima fixa o campo de select aberto no canto sup esq -->
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Data de início (mais antigo):</span>
                <div class="cardIconCalendar ml-1 mb-2" @click="tmpSaveVar('init','dtStr')">
                    <v-icon @click="tmpSaveVar('init','dtStr')">mdi-calendar</v-icon>
                </div>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.dt_str_init"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="01/01/2001"
                        @change="flagMsgErro = false"
                    />
                    <!-- @change="atualizarFormulario()" -->
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Hora de início:</span>
                <div class="cardIconCalendar ml-1 mb-1" @click="tmpSaveVar('init','hrStr')">
                    <v-icon @click="tmpSaveVar('init','hrStr')">mdi-clock</v-icon>
                </div>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.hhmm_init"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="00:01"
                        @change="flagMsgErro = false"
                    />
                    <!-- @change="atualizarFormulario()" -->
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Data de fim (mais recente):</span>
                <div class="cardIconCalendar ml-1 mb-1" @click="tmpSaveVar('end','dtStr')">
                    <v-icon @click="tmpSaveVar('end','dtStr')">mdi-calendar</v-icon>
                </div>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.dt_str_end"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="01/01/2001"
                        @change="flagMsgErro = false"
                    />
                    <!-- @change="atualizarFormulario()" -->
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Hora de fim:</span>
                <div class="cardIconCalendar ml-1 mb-1" @click="tmpSaveVar('end','hrStr')">
                    <v-icon @click="tmpSaveVar('end','hrStr')">mdi-clock-outline</v-icon>
                </div>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.hhmm_end"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="00:01"
                        @change="flagMsgErro = false"
                    />
                    <!-- @change="atualizarFormulario()" -->
                </div>
            </div>

        </div>

        <v-btn @click="search()" v-if="!flagMsgErro"
        class="mt-2 mb-2"
        block 
        :style="{'background':'#f39c12','color':'white','white-space':'normal !important'}"
        >Buscar</v-btn>

        <div v-if="flagMsgErro" class="mt-1 mb-2" :style="{'align-self':'center','color':'white','font-size':'0.8rem','font-weight':'100'}">{{ msgErro }}</div>
    </div>
</template>

<script>
import { convToUtc } from "../auxSC/timeConv.js";

import DialogCalendar from './DialogCalendar'
import DialogHR from './DialogHR'

export default {

    components:{DialogCalendar,DialogHR},

    props:['agent_unit','cl','sys_agend','flagStrWrap','liSeI'],

    data() {
        return {

            // estrutural
            flagMsgErro:false,
            msgErro:'Preencha corretamente todos os campos.',
            flagLoading:true,
            flagDialog:false, // calendar
            flagDialogHR:false, // horário

            // -- default form
            formLocal: {
                'device_id':'',
                'atuador':'',
                'target_key':'',
                'dt_str_init':'01/01/2001', // mais antigo
                'hhmm_init':'05:01',
                'dt_str_end':'01/01/2001', // mais recente
                'hhmm_end':'05:01',
            },
            var_init_or_end:null,
            varstrHR:null,

            // -- handle atuadores.
            liDevicesExib: [], // sensores + indices calculados | rcv from father via props
            liExibSelect:[],
            deviceSelected: '',
        }
    },

    methods:{

        desableDialogDT(resDialog) { 
            //console.log('[SelectExib][desableDialogDT] resDialog:',resDialog)
            if (this.var_init_or_end == 'init') { this.formLocal.dt_str_init = resDialog }
            else { this.formLocal.dt_str_end = resDialog }
            this.flagDialog = false
        },

        desableDialogHR(resDialog) { 
            //console.log('[SelectExib][desableDialogHR] resDialog:',resDialog)
            if (this.var_init_or_end == 'init') { this.formLocal.hhmm_init = resDialog }
            else { this.formLocal.hhmm_end = resDialog }
            this.flagDialogHR = false
        },

        tmpSaveVar(varStrINITorEND, varstrDTorHR) {
            //console.log('[SelectExib][tmpSaveVar] start')
            this.var_init_or_end = varStrINITorEND
            this.varstrHR = varstrDTorHR
            // SELECIONAR qual dialog abrir.
            if (varstrDTorHR == 'hrStr') { this.flagDialogHR = true }
            else { this.flagDialog = true }
            //console.log('[SelectExib][tmpSaveVar] end')
        },

        tmpSaveIndex(index) {

            this.flagMsgErro = false // reabilitar btn search()

            const itemSelected = this.liExibSelect[index]

            if (!itemSelected) return

            this.formLocal.device_id = itemSelected.device_id

            //console.log("index:", index)
            //console.log("device_id:", itemSelected.device_id)
        },

        rangeToDate(range) {
            const [data, hora] = range.split('-')
            const [dd, mm, yyyy] = data.split('/').map(Number)
            const [hh, min] = hora.split(':').map(Number)

            return new Date(Date.UTC(yyyy, mm - 1, dd, hh, min))
        },

        search() { // -- validar form.

            const indexLocal = this.deviceSelected // montado em tmpSaveIndex()
            const itemSelected = this.liExibSelect[indexLocal]
            //console.log('itemSelected: ',itemSelected)
            //console.log('this.formLocal: ',this.formLocal)

            if (typeof itemSelected === "undefined") {
                this.msgErro = 'Preencha corretamente todos os campos.'
                this.flagMsgErro = true; 
                return 
            }

            const tzName = this.$store.state.fusoHorarioSC // esperado algo como --> "Europe/Lisbon"

            // INIT (validação do formato da data do input)
            let resUTCInit = null
            let flag_hhmm_e_dtStr_ok = this.atualizarFormulario(
                this.formLocal['dt_str_init'], 
                this.formLocal['hhmm_init']
            )
            if (flag_hhmm_e_dtStr_ok == false) { 
                this.msgErro = 'Preencha corretamente todos os campos.'
                this.flagMsgErro = true; 
                return 
            }
            else { 
                resUTCInit = convToUtc(
                    this.formLocal['dt_str_init'], 
                    this.formLocal['hhmm_init'], 
                    tzName
                )
                this.flagMsgErro = false 
            }

            // END (validação do formato da data do input)
            let resUTCEnd = null
            flag_hhmm_e_dtStr_ok = this.atualizarFormulario(
                this.formLocal['dt_str_end'], 
                this.formLocal['hhmm_end']
            )
            if (flag_hhmm_e_dtStr_ok == false) { 
                this.msgErro = 'Preencha corretamente todos os campos.'
                this.flagMsgErro = true; 
                return 
            }
            else { 
                resUTCEnd = convToUtc(
                    this.formLocal['dt_str_end'], 
                    this.formLocal['hhmm_end'], 
                    tzName
                )
                this.flagMsgErro = false 
            }

            //console.log('resUTCInit: ',resUTCInit)
            //console.log('resUTCEnd: ',resUTCEnd)

            const endForm = {
                //"api_client":"",
                "range_init":`${resUTCInit.dataUtcStr}-${resUTCInit.hhmmUtc}`,
                "range_end":`${resUTCEnd.dataUtcStr}-${resUTCEnd.hhmmUtc}`,
                "device_id":itemSelected.device_id,
                "titulo":itemSelected.titulo,
                "sub_marcador":itemSelected.sub_marcador // target_key
            }
            //console.log('endForm: ',endForm)

            // VALIDAR ORDEM DAS DATAS range
            const dtInit = this.rangeToDate(endForm.range_init)
            const dtEnd = this.rangeToDate(endForm.range_end)
            if (dtEnd <= dtInit) {
                console.log('[SelectExib][search] range_end deve ser maior que range_init')
                //this.flagLoading = false
                this.msgErro = 'A data de fim deve ser maior do que a data de início.'
                this.flagMsgErro = true
                return
            }

            // -- emitir input endForm.
            this.$emit('formFromChild', endForm) // dict input_last_info
        },

        atualizarFormulario(dt_str, hhmm) {

            //console.log('formLocal: ',this.formLocal)

            // -- verificação se o momento da irrigação está no formato correto.
            const flag_fmt_hhmm_ok = this.validarHoraHhmm(hhmm)
            const flag_fmt_dtStr_ok = this.validarDataDdMmAaaa(dt_str)
            if (flag_fmt_hhmm_ok && flag_fmt_dtStr_ok) { 
                this.flagMsgErro = false // reset msg erro (se houver)
                return true
            }
            else { 
                this.flagMsgErro = true // habilitar msg erro
                this.msgErro = 'Formatos 01/01/2001 e 00:02 obrigatório.'
                this.formLocal['hhmm_init'] = '05:02' // reset para o fmt correto
                this.formLocal['dt_str_init'] = '01/01/2001' // reset para o fmt correto
                this.formLocal['hhmm_end'] = '05:02' // reset para o fmt correto
                this.formLocal['dt_str_end'] = '01/01/2001' // reset para o fmt correto
                return false
            }
        },

        validarHoraHhmm(valor) {
            const regex = /^(\d{2}):(\d{2})$/;
            const match = valor.match(regex);

            if (!match) return false;

            const hora = parseInt(match[1], 10);
            const minuto = parseInt(match[2], 10);

            return (
                hora >= 0 &&
                hora <= 23 &&
                minuto >= 0 &&
                minuto <= 59
            );
        },

        validarDataDdMmAaaa(valor) {
            const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            const match = valor.match(regex);

            if (!match) return false;

            const dia = parseInt(match[1], 10);
            const mes = parseInt(match[2], 10);
            const ano = parseInt(match[3], 10);

            if (mes < 1 || mes > 12) return false;

            const dt = new Date(ano, mes - 1, dia);

            return (
                dt.getFullYear() === ano &&
                dt.getMonth() === mes - 1 &&
                dt.getDate() === dia
            );
        },

        convStrToDt(dateHrUtc) {
            const [data, hora] = dateHrUtc.split("-");
            const [dia, mes, ano] = data.split("/").map(Number);
            const [hh, mm] = hora.split(":").map(Number);

            return new Date(Date.UTC(ano, mes - 1, dia, hh, mm));
        },

        init() {
            this.flagLoading = true // fechar form
            this.liExibSelect = this.liSeI // rcv via props
            let c=0
            while ( c < this.liExibSelect.length ) {
                this.liExibSelect[c]['idLocal'] = c
                c++
            }
            this.flagLoading = false // abrir form
        },
    },

    created() { this.init() }
}
</script>
